import React from 'react';
import { Trophy } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function GamificationPage() {
  const module = getModule('gamification')!;
  return (
    <ModulePageLayout module={module} Icon={Trophy}>
      <Section title="Get Rewarded for Good Financial Habits">
        <p className="text-gray-700 leading-relaxed">
          Gamification & Referrals drives engagement through points, challenges, and referral rewards. Points
          are earned through platform activity and can be Fixed (one-time), Activity-based (recurring), or
          Bonus (special promotions) — each tracked from Issued through Redeemed, Expired, or Cancelled.
        </p>
      </Section>

      <Section title="Refer a Friend">
        <FeatureGrid
          items={[
            { title: 'Unique Referral Codes', body: 'Every user gets their own referral code with an expiration date.' },
            { title: 'Status Tracking', body: 'Referred users move through Pending, Accepted, Active, or Inactive — visible to the referrer.' },
            { title: 'Rewards for Both Sides', body: 'A successful referral earns rewards for both the referrer and the new user.' },
            { title: 'Fraud Prevention', body: 'Detailed referral logging tracks IP address and user agent to keep the rewards system honest.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
